export default class HumanReadableTime {
    time: number;

    constructor(time) {
        this.time = time;
    }

    get days() {
        return Math.floor(Math.abs(this.time) / (60 * 60 * 24));
    }

    get hours() {
        return Math.floor((Math.abs(this.time) / (60 * 60)) % 24);
    }

    get minutes() {
        return Math.floor((Math.abs(this.time) / 60) % 60);
    }

    get seconds() {
        return Math.floor(Math.abs(this.time) % 60);
    }
}
